import moment, { Moment } from 'moment';
import { isPossiblePhoneNumber } from 'react-phone-number-input/min';

import { EMAIL_REGEX } from '../constants';

export const validate = (inputName: string, required?: string | boolean) => {
  const isRequired = required || required === 'required';

  switch (inputName) {
    case 'firstName':
    case 'lastName':
    case 'locationName':
    case 'address':
    case 'address2':
    case 'state':
    case 'city':
    case 'practiceName':
      return {
        ...(isRequired && { required: 'This is required' }),
        maxLength: { value: 36, message: 'Max length is 36' },
      };

    case 'postalCode':
      return {
        ...(isRequired && { required: 'This is required' }),
        maxLength: { value: 16, message: 'Max length is 16' },
      };

    case 'salutation':
      return {
        ...(isRequired && { required: 'This is required' }),
        maxLength: { value: 20, message: 'Max length is 20' },
      };

    case 'practitionerId':
      return {
        ...(isRequired && { required: 'This is required' }),
        maxLength: { value: 36, message: 'Max length is 36' },
        minLength: { value: 36, message: 'Min length is 36' },
      };

    case 'faxNumber':
    case 'phoneNumber':
      return {
        ...(isRequired && { required: 'This is required' }),
        validate: (value: string) => {
          if (!value) {
            return 'This is required';
          }
          if (!isPossiblePhoneNumber(value)) {
            return 'Invalid phone number';
          }
          return true;
        },
      };

    case 'email':
    case 'emailAddress':
      return {
        ...(isRequired && { required: 'This is required' }),
        pattern: { value: EMAIL_REGEX, message: 'Invalid email address' },
      };

    case 'acceptTerms':
      return {
        ...(isRequired && {
          validate: (value: string) => {
            if (value !== 'true') {
              return 'This is required';
            }

            return true;
          },
        }),
      };

    case 'prenuvoId':
      return {
        ...(isRequired && { required: 'Please search for Associated Prenuvo Account' }),
      };

    case 'dob':
      return {
        ...(isRequired && { required: 'This is required' }),
        validate: (value: string) => {
          if (value) {
            const isOutsideRange = (day: Moment) => day.isAfter(moment());

            if (!moment(value).isValid()) {
              return 'Invalid date of birth';
            }

            if (isOutsideRange(moment(value))) {
              return 'Invalid date of birth';
            }
          }
        },
      };

    case 'year':
      return {
        ...(isRequired && { required: 'This is required' }),
        validate: (value: string) => {
          if (value.length !== 4 || isNaN(+value)) {
            return 'Invalid year';
          }

          if (!isNaN(+value)) {
            if (!(+value >= 1900 && value <= moment().format('YYYY'))) {
              return `Year should be selected between 1900 and ${moment().format('YYYY')}`;
            }
          }
        },
      };

    case 'month':
      return {
        ...(isRequired && { required: 'This is required' }),
        validate: (value: string) => {
          if (value.length !== 2 || isNaN(+value)) {
            return 'Invalid month';
          }

          if (!isNaN(+value)) {
            if (!(+value >= 1 && +value <= 12)) {
              return 'Invalid month';
            }
          }
        },
      };

    case 'day':
      return {
        ...(isRequired && { required: 'This is required' }),
        validate: (value: string) => {
          if (value.length !== 2 || isNaN(+value)) {
            return 'Invalid day';
          }

          if (!isNaN(+value)) {
            if (!(+value >= 1 && +value <= 31)) {
              return 'Invalid day';
            }
          }
        },
      };

    case 'dob':
      return {
        validate: (value: string) => {
          if (value) {
            if (!moment(value).isValid() || moment(value).isAfter(moment())) {
              return 'Invalid Date of Birth';
            }

            const age = moment().diff(moment(value), 'year');
            if (age < 18) {
              return `You must be at least 18 years of age to book online. Please contact our Member Support team at <a href="tel:+18337736886">+1 833 773 6886</a> to book over the phone.`;
            }
          }
        },
      };

    default:
      return {
        ...(isRequired && { required: 'This is required.' }),
      };
  }
};
